import { Button, Col, Typography, useTheme } from "@commonlibs";
import clsx from "clsx";
import CameraQRReader from "ui/common/components/input/CameraQRReader/CameraQRReader";
import useTranslate from "ui/locale/hooks/useTranslate";
import { ScanQrWithButtonProps } from "./ScanQrWithButton.types";

function ScanQrWithButton({ className, buttonLabel, onScan, onClick, disabled, ...rest }: ScanQrWithButtonProps) {
    const translate = useTranslate();
    const { spacing } = useTheme();

    return (
        <Col className={clsx("scan-qr-with-button", className)} gap={8} justifyContent="space-between" {...rest}>
            <Col gap={spacing["6"]}>
                <CameraQRReader onScan={onScan} css={{ maxHeight: "100%" }} />
                <Typography variant="body3Medium" light textAlign="center">
                    {translate("scanToPay")}
                </Typography>
            </Col>
            <Button disabled={disabled} onClick={onClick} variant="primary">
                {buttonLabel}
            </Button>
        </Col>
    );
}

export default ScanQrWithButton;
